import React, { Component } from "react";
import { connect } from "react-redux";

//import "./FSEManagement.styles.scss";
import { Link } from "react-router-dom";
import { Button, Icon, Divider } from "react-materialize";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import axios from "axios";
import { FacematchAxiosClient } from "../../../../../../Network/FacematchAxiosClient";
import EditUser from "./components/EditUser";
import { normalizeString } from "../../../GeopgraphyTable/components/utils/normalizeString";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import EscapeOutside from "react-escape-outside";
import BounceLoader from "react-spinners/BounceLoader";
import "./UserDetails.styles.scss";
import placeholder from "./placeholder.png";
import { Dialog, IconButton } from "@material-ui/core";

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={handleClose}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  );
};

export class UserDetails extends Component {
  constructor() {
    super();

    this.state = {
      data_fetching: false,
      enableEdit: true,
      showDeleteConfirm: false,
      deleting: false,
      resigning_date: format(new Date(), "yyyy-MM-dd"),
    };
  }

  componentDidMount() {}

  editResigningDate = (date) => {
    this.setState({ resigning_date: format(new Date(date), "yyyy-MM-dd") });
  };

  handleUnregisterFacematching = () => {
    var userData = { ...this.props.location.state.data };
    console.log(userData);
    FacematchAxiosClient.post("/selfie/unregister", {
      appName: "nimontron",
      userId: userData.contact_number.slice(1), // remove it in future CR after face match backend is fixed (change unique id to employee id from whitelisting_number)
      employeeId: userData.employee_id,
    })
      .then(() => alert("User unregistered from facematching successfully."))
      .catch((err) => alert("User unregisteration from facematching failed."));
  };
  activateUser = () => {
    var userData = { ...this.props.location.state.data };

    axios
      .put(`${process.env.REACT_APP_API_URL}/api/users/api/v1/user`, userData, {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      })
      .then((res) => {
        console.log(res);

        alert("User activated");
        this.props.history.push("/user");
      })
      .catch((err) => {
        alert("Something went wrong!");
      });
  };
  deleteUser = () => {
    var controlObject = { ...this.props.location.state.controlObject };
    this.setState({ deleting: true });
    if (
      controlObject["id"] === "agency_user" ||
      controlObject["id"] === "territory_manager"
    ) {
      this.handleUnregisterFacematching();
    }
    var obj = { id: this.props.location.state.data["id"] };
    if (controlObject["id"] === "agency_user")
      obj = { ...obj, resigning_date: this.state.resigning_date };
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/api/users/api/v1/user`,

        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
          data: { ...obj },
        }
      )
      .then((res) => {
        alert(`Successfully deactivated ${controlObject["lable"]} `);
        console.log("success");

        this.setState({ showDeleteConfirm: false, deleting: false });
        this.props.history.push("/user");
      })
      .catch((err) => {
        console.log(err);
        this.setState({ showDeleteConfirm: false, deleting: false });
      });
  };

  render() {
    // console.log(this.props.location.state.data);
    var userData = { ...this.props.location.state.data };
    var controlZones = { ...this.props.location.state.controlZones };
    var controlObject = { ...this.props.location.state.controlObject };
    var currentUserType = JSON.parse(localStorage.getItem("currUserType"));

    const isFaceMatchUnregisterActive =
      currentUserType === "bkash-super-user" ||
      currentUserType === "cluster_head" ||
      currentUserType === "regional_manager" ||
      currentUserType === "area_manager";
    return (
      <div className="main-container">
        {this.state.data_fetching ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="header-bg">
              <div className="header-container">
                {/* <div
                  //onClick={() => this.props.changeTo("fse")}
                  className="back-btn"
                >
                  <Link to="/user">
                    <Icon className="back-icn">chevron_left</Icon>
                  </Link>
                </div> */}
                <div className="fse-details">
                  <div className="img-container">
                    <img
                      className="user-image"
                      src={placeholder}
                      alt={"Bkash"}
                    />
                  </div>
                  <div className="name-phone">
                    <div
                      className="name-tag"
                      style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <h2 className="name" style={{ marginBottom: 5 }}>
                        {normalizeString(userData.username)}
                      </h2>
                      <p
                        className="tag"
                        style={{
                          margin: 0,
                          background: "transparent",
                          fontWeight: 500,
                          paddingLeft: 0,
                          marginBottom: 2,
                          color: "#e2136e",
                        }}
                      >
                        {normalizeString(controlObject["lable"])}
                      </p>
                      <h3 className="contact-number" style={{ margin: 0 }}>
                        {userData.contact_number}
                      </h3>
                      {!userData.is_active && userData.resigning_date && (
                        <h3 className="resiging-date">
                          Resigned at{" "}
                          <b>
                            {format(
                              new Date(userData.resigning_date),
                              "MMM dd, yyyy"
                            )}
                          </b>
                        </h3>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-all">
                  <div
                    className="btn-group"
                    style={{ flexDirection: "column", alignItems: "center" }}
                  >
                    <div className="delete-container">
                      {userData.is_active ? (
                        <button
                          onClick={() =>
                            this.setState({ showDeleteConfirm: true })
                          }
                        >
                          <DeleteForeverIcon className="delete-icon" />
                          Deactivate
                        </button>
                      ) : (
                        <button
                          onClick={this.activateUser}
                          style={{
                            border: "1px solid green",
                            padding: "8px",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: 5,
                            fontFamily: "monospace",
                            color: "green",
                          }}
                        >
                          Activate
                        </button>
                      )}
                    </div>
                    {userData.is_active && (
                      <p
                        className="unregister-facematch-user"
                        onClick={() => this.handleUnregisterFacematching()}
                      >
                        Unregister Facematch
                      </p>
                    )}

                    {/* <ViewLogModal
                      handleHide={this.hideViewLogModal}
                      show={this.state.showViewLogModal}
                      id={this.state.id}
                      name={this.state.name}
                      phone={this.state.phone}
                      agency={this.state.agency}
                      logs={this.state.logs}
                    /> */}
                  </div>
                  <div className="replace-btn">
                    {/* <Button
                      className="im-secondary"
                      //onClick={this.showReplaceFSEModal}
                    >
                      <Icon left>code</Icon>Replace FSE
                    </Button> */}
                    {/* <ReplaceFSEModal
                      handleHide={this.hideReplaceFSEModal}
                      show={this.state.showReplaceFSEModal}
                      id={this.state.id}
                      name={this.state.name}
                      phone={this.state.phone}
                      agency={this.state.agency}
                      handleSubmit={this.handleReplace}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              open={this.state.showDeleteConfirm}
              onClose={() => this.setState({ showDeleteConfirm: false })}
            >
              <div
                className="wrapper-modal"
                style={{ width: 600, height: 400 }}
              >
                <div className="modal-header">
                  <div className="headline">
                    <div className="main-headline">
                      <b>{userData.username}</b>
                    </div>
                    <div className="sub-headline"></div>
                  </div>
                </div>
                <div className="modal-body">
                  Are you sure want to deactivate this user ?
                </div>
                {controlObject["id"] === "agency_user" && (
                  <div className="datepicker-user-detail">
                    <label>Resigning date</label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        label="Birth Date"
                        format="dd/MM/yyyy"
                        value={format(
                          new Date(this.state.resigning_date),
                          "yyyy-MM-dd"
                        )}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={this.editResigningDate}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                )}
                <div className="footer" style={{ marginTop: 10 }}>
                  {/* <BounceLoader
                  className="loader"
                  color={"#e2136e"}
                  size={20}
                  loading={!this.state.deleting}
                /> */}

                  <button
                    className="button--cancel"
                    onClick={() => this.setState({ showDeleteConfirm: false })}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button className="button--save" onClick={this.deleteUser}>
                    {this.state.deleting ? "Deactivating" : "Yes"}
                  </button>
                </div>
              </div>
            </Dialog>

            {/* <div className="mdo-display">
              <h2>User Details</h2>
              <p className="mdo-count">{this.state.total}</p>
            </div> */}

            <Divider />

            <div className="content">
              <EditUser
                userData={userData}
                controlZones={controlZones}
                controlObject={controlObject}
                enableEdit={this.state.enableEdit}
              />
              {/* <Pagination
                page={`fsemdomanage`}
                currentPage={this.props.currentPage}
                total={this.state.total}
                limit={this.props.currentLimit}
              /> */}
            </div>
          </>
        )}
        {/* <Footer /> */}
      </div>
    );
  }
}

export default UserDetails;
